module.exports = __webpack_public_path__ + "img/DK.a830e4ce.svg";